<template>
    <div class="d-flex justify-content-end w-100">
        <div v-if="!!canAccessKeep" class="subnav-link" @click="showKeepModal" :title="trans('course.creator.elements.Keep')">
            <img src="/images/svg-icons/marlms-keep-orange.svg" class="inactive-icon svg-with-hover-2" style="opacity: 1;">
        </div>
        <student-keep
            v-if="showStudentKeep"
            :course-keep-sections="keepSections"
            :free-course="false"
            :preview="false"
            :trigger-data="{}"
            :student="student"
            :student-course-id="studentCourseId"
            :course-name="courseName"
            @modal-closed="keepModalClosed"
            :read-only="readOnly"
        ></student-keep>
        <div @click="showProgressModal" class="order-3 subnav-link hover-image pointer ml-1"
             :title="trans('overview')['students.progress.progress']">
            <progress-ring class="svg-with-hover-2" :min="0" :max="100" ring-color="#F67E00" :value="progress" :text="progress"></progress-ring>
        </div>
        <div class="order-2 ml-2">
            <div class="modal fade" ref="progressModal" tabindex="-1" role="dialog" aria-hidden="true"
                 style="visibility: hidden">
                <div class="modal-dialog modal-dialog-scrollable" role="document" style="visibility: visible">
                    <div class="modal-content min-keep-size resize">
                        <div class="modal-header flex mb-2">
                            <h5 class="modal-title mb-2" id="progressModalLabel">
                                {{ trans('overview')['students.progress.progress'] }}
                                <div style="font-size: small">{{ courseName }}</div>
                            </h5>
                            <div>
                                <i v-if="passedLessonsHidden" aria-hidden="true" class="far fa-eye" style="color: #333" :title="trans('course')['student_course_map.show_all']" @click.prevent="togglePassed"></i>
                                <i v-else aria-hidden="true" class="far fa-eye-slash" style="color: #333" :title="trans('course')['student_course_map.hide_completed']" @click.prevent="togglePassed"></i>
                                <button type="button" class="close no-drag" @click.prevent="hideProgressModal">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="section-map">
                                <div v-for="(element, sid) in map">
                                    <div :class="'course-map-' + element.type" class="map-first">
                                        <div class="map-wrapp" @click="expandMap($event, element)">
                                            <a :id="'section-' + element.iId"
                                                class="map-section pointer">
                                                {{ element.name ? element.name : trans('course.untitled.' + (isNaN(element.type) ? element.type : 'chapter')) }}
                                                <template v-if=" element.minutes || element.seconds">(
                                                    <template v-if="element.minutes">{{ element.minutes }} min</template>
                                                    <template v-if="element.seconds">{{ element.seconds }} sec</template>
                                                    )
                                                </template>
                                            </a>
                                            <i v-if="element.type == 1 && element.children.length"
                                               class="fas fa-angle-down"></i>
                                        </div>
                                        <div class="children-map" :class="'children-' + element.iId">
                                            <div v-for="child in element.children" :class="'map-' + child.type" class="section-child">
                                                <a :id=" 'creator-map-' + child.iId"
                                                class="map-section child-map pointer">
                                                    <div
                                                        class="chapter-item"
                                                        :id=" 'map-' + child.type + '-' + (child.type == 'quiz' ? child.quiz_id : child.id)">
                                                        {{ child.name ? child.name : trans('course.untitled.' + (isNaN(child.type) ? child.type : 'chapter')) }}
                                                        <template v-if=" child.minutes || child.seconds">(
                                                            <template v-if=" child.minutes">{{ child.minutes }} min
                                                            </template>
                                                            <template v-if=" child.seconds">{{ child.seconds }} sec
                                                            </template>
                                                            )
                                                        </template>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click.prevent="hideProgressModal">
                                {{trans('training.role_user.close')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StudentKeep from "./StudentKeep";

export default {
    name: "StudentCourseDetailsViewer",
    components: {StudentKeep},
    props: {
        canAccessKeep: String,
        studentCourseId: Number,
        courseName: String,
        courseId: Number,
        student: Object,
        progress: {
            type: Number,
            default: 0,
        },
        readOnly: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            keepSections: [],
            showStudentKeep: false,
            sections: [],
            map: [],
            passedLessonsHidden: false,
        }
    },
    mounted() {
    },
    methods: {
        togglePassed() {
            if (this.passedLessonsHidden) {
                Array.from(document.querySelectorAll('.passed.d-none')).forEach(element => element.classList.remove('d-none'));
                Array.from(document.querySelectorAll('.section-child.d-none')).forEach(element => element.classList.remove('d-none'));
                Array.from(document.querySelectorAll('.map-first.d-none')).forEach(element => element.classList.remove('d-none'));
                this.passedLessonsHidden = false;
            } else {
                Array.from(document.querySelectorAll('.passed')).forEach(element => element.classList.add('d-none'));
                Array.from(document.querySelectorAll('.map-first')).forEach(mapSection => {
                    const unpassedLessons = mapSection.querySelectorAll('.map-lesson .chapter-item:not(.passed)').length;
                    const unpassedQuizzes = mapSection.querySelectorAll('.map-quiz .chapter-item:not(.passed)').length;
                    if (!unpassedLessons && !unpassedQuizzes) {
                        mapSection.classList.add('d-none');
                    } else {
                        let currentChapterElement = null;
                        // Convert HTMLCollection to Array before using forEach
                        Array.from(mapSection.children).forEach(mapElement => {
                            if (mapElement.classList.contains('map-wrapp')) return;
                            // Convert the nested HTMLCollection to Array too
                            Array.from(mapElement.children).forEach(childrenMapElement => {
                                if (!childrenMapElement.classList.contains('map-lesson') && !childrenMapElement.classList.contains('map-quiz')) {
                                    currentChapterElement = childrenMapElement;
                                    currentChapterElement.classList.add('d-none');
                                } else {
                                    if (childrenMapElement.querySelectorAll('.chapter-item:not(.passed)').length) {
                                        currentChapterElement?.classList.remove('d-none');
                                    }
                                }
                            });
                        });
                    }
                });
                this.passedLessonsHidden = true;
            }
        },
        async showKeepModal() {
            await this.getCourse();
            await this.getStudentKeepData();
            this.showStudentKeep = true;
        },
        async showProgressModal() {
            await this.getCourse();
            await this.getCourseStudent()
            $(this.$refs.progressModal).modal('show');
        },
        hideProgressModal() {
            $(this.$refs.progressModal).modal('hide');
        },
        expandMap: function (event, element) {
            if (element.type !== 1 || !element.children.length) {
                return false;
            }
            let id = element.iId;
            $(".children-" + id).toggle();
        },
        getKeepData: function () {
            this.keepSections = [];
            let self = this;
            this.sections.forEach(function (section) {
                let data = {
                    id: section.id,
                    name: section.name,
                    type: section.type,
                    content: [],
                }
                let parsableContent;
                if (['lesson', 'quiz'].includes(section.type)) {
                    parsableContent = section.content;
                } else {
                    parsableContent = section.descriptionBlocks;
                }

                if (parsableContent) {
                    JSON.parse(parsableContent).forEach(function (keep, idx) {
                        let dataKeep = {
                            lid: section.id, //keep container id
                            ltype: section.type, //keep container type
                            id: idx,
                            content: keep,
                            showEditor: false,
                            keepStudent: keep.keep,
                        }
                        data.content.push(dataKeep);
                    });
                }
                self.keepSections.push(data);
            });
        },
        async getStudentKeepData() {
            let $end = '/api/get-student-keep/' + this.studentCourseId + '/' + this.student.id;
            let self = this;
            await axios.get($end).then((response) => {
                response = response.data;
                this.keepSections.forEach((keepSection, index) => {
                    keepSection.content.forEach((keepEditorBlock, keepIndex) => {
                        let studentKeepContents;
                        switch (keepEditorBlock.ltype) {
                            case 1: //chapter and subchapter types
                            case 2:
                            case 3:
                            case 4:
                                studentKeepContents = response.filter((studentKeep) => studentKeep.section_id === keepEditorBlock.lid && studentKeep.keep_id === keepEditorBlock.id);
                                if (studentKeepContents.length === 1) {
                                    this.keepSections[index].content[keepIndex].keepStudent = studentKeepContents[0].keep;
                                }
                                break;
                            default: //lessons quizzes etc
                                studentKeepContents = response.filter((studentKeep) => studentKeep.lesson_id === keepEditorBlock.lid && studentKeep.keep_id === keepEditorBlock.id);
                                if (studentKeepContents.length === 1) {
                                    this.keepSections[index].content[keepIndex].keepStudent = studentKeepContents[0].keep;
                                }
                                break;
                        }
                    });
                });
                this.keepSections = [...this.keepSections];
            }).catch(err => {
                this.$data.loader = false;
            });
        },
        getCourse: async function () {
            let $end = "/api/get-student-course-course-content-api/" + this.studentCourseId;

            let self = this;
            // self.lessonsNo = 0;
            // self.quizzesNo = 0;
            // self.quizzesNoCert = 0;
            await axios
                .get($end)
                .then(async function (response) {
                    response = response.data;
                    self.token = response.token;
                    self.course = response.course;
                    self.courseName = self.course.name;
                    self.courseDescription = self.course.description;

                    self.show_certificate_when =
                        response.course.show_certificate_when;

                    if (
                        response.show_certificate_when &&
                        response.show_certificate_when != 1
                    ) {
                    }
                    //self.show_certificate_when = response.show_certificate_when;

                    let idxp;
                    let iId = 0;
                    self.sections = [];
                    self.map = [];
                    self.course.sections.forEach(function (section) {
                        self.sectionGoals = [];
                        if (section.section_type == 1) {
                            section.type = 1;
                            section.children = [];
                            section.iId = iId;
                            iId++;

                            let chapterStart;
                            section.lessons.forEach(function (lesson) {
                                if (
                                    (lesson.type != "quiz" ||
                                        lesson.quiz.quiz_type != "exam" ||
                                        lesson.quiz.show_exam_in_content) &&
                                    !lesson.hide &&
                                    (lesson.quiz ? !lesson.quiz.hide : true)
                                ) {
                                    lesson.type =
                                        lesson.type == "quiz"
                                            ? "quiz"
                                            : "lesson";
                                    lesson.iId = iId;
                                    section.children.push(lesson);
                                    iId++;
                                }
                            });
                            self.map.push(section);
                            idxp = self.map.length - 1;

                            if (section.goal_blocks) {
                                self.sectionGoals = JSON.parse(
                                    section.goal_blocks
                                );
                            }
                        }
                        if ([2, 3, 4].includes(section.section_type)) {
                            section.type = section.section_type;
                            section.iId = iId;
                            iId++;
                            self.map[idxp].children.push(section);
                            section.lessons.forEach(function (lesson) {
                                if (
                                    (lesson.type != "quiz" ||
                                        lesson.quiz.quiz_type != "exam" ||
                                        lesson.quiz.show_exam_in_content) &&
                                    !lesson.hide &&
                                    (lesson.quiz ? !lesson.quiz.hide : true)
                                ) {
                                    lesson.type =
                                        lesson.type == "quiz"
                                            ? "quiz"
                                            : "lesson";
                                    lesson.iId = iId;
                                    iId++;
                                    self.map[idxp].children.push(lesson);
                                }
                            });

                            if (
                                section.goal_blocks &&
                                JSON.parse(section.goal_blocks)[0]
                            ) {
                                self.sectionGoals = JSON.parse(
                                    section.goal_blocks
                                );
                            } else {
                                let allSections = self.course.sections;

                                let pIdx = allSections.findIndex(
                                    x => x.id === section.pivot.section_parent
                                );

                                if (
                                    pIdx != -1 &&
                                    allSections[pIdx].goal_blocks &&
                                    JSON.parse(allSections[pIdx].goal_blocks)[0]
                                ) {
                                    self.sectionGoals = JSON.parse(
                                        allSections[pIdx].goal_blocks
                                    );
                                } else {
                                    pIdx = allSections.findIndex(
                                        x =>
                                            x.id ===
                                            section.pivot.chapter_parent
                                    );

                                    if (
                                        pIdx != -1 &&
                                        allSections[pIdx].goal_blocks &&
                                        JSON.parse(
                                            allSections[pIdx].goal_blocks
                                        )[0]
                                    ) {
                                        self.sectionGoals = JSON.parse(
                                            allSections[pIdx].goal_blocks
                                        );
                                    } else {
                                        pIdx = allSections.findIndex(
                                            x =>
                                                x.id ===
                                                section.pivot.subchapter_parent
                                        );
                                        if (
                                            pIdx != -1 &&
                                            allSections[pIdx].goal_blocks
                                        ) {
                                            self.sectionGoals = JSON.parse(
                                                allSections[pIdx].goal_blocks
                                            );
                                        }
                                    }
                                }
                            }
                        }

                        let data = {
                            name: section.name,
                            goal: section.goal,
                            goals: self.sectionGoals,
                            description: section.description,
                            descriptionBlocks: section.description_blocks,
                            goalBlocks: section.goal_blocks,
                            id: section.id,
                            type: section.section_type,
                            seconds: 0,
                            minutes: 0,
                            parent: section.pivot
                        };

                        self.sections.push(data);
                        let lessonsBreak = {type: 'lesson', lessons: [], goals: []};
                        section.lessons.forEach(function (lesson, keyL) {
                            // if (lesson.type != 'quiz' && !lesson.hide) {
                            //     self.lessonsNo = self.lessonsNo + 1;
                            // }
                            // if (lesson.type == 'quiz' && lesson.quiz && !lesson.quiz.hide) {
                            //     self.quizzesNo = self.quizzesNo + 1;
                            //     // if (lesson.quiz.required_graduation) {
                            //     //     self.quizzesNoCert = self.quizzesNoCert + 1;
                            //     // }
                            // }
                            let content = lesson.type == 'quiz' ? lesson.quiz.content : lesson.content;
                            let data = {
                                name: lesson.name,
                                description: lesson.description ? lesson.description : '',
                                content: content,
                                id: lesson.id,
                                type: lesson.type == 'quiz' ? 'quiz' : 'lesson',
                                showEditor: false,
                                qid: lesson.quiz_id,
                                seconds: lesson.seconds,
                                minutes: lesson.minutes,
                                goals: self.sectionGoals,
                                quiz: lesson.quiz_id ? lesson.quiz : null,
                                keep: '<img  @click="show(content)"  data-toggle="tooltip" data-placement="top" title="Keep" class="pointer keep-image next-link" src="../images/KeeP Button.png">'
                            }

                            // self.addChapterMinutes(0, lesson);

                            if (
                                (lesson.type != "quiz" ||
                                    lesson.quiz.quiz_type != "exam" ||
                                    lesson.quiz.show_exam_in_content) &&
                                !lesson.hide &&
                                (lesson.quiz ? !lesson.quiz.hide : true)
                            ) {
                                self.sections.push(data);
                            }
                        });

                        self.sections.forEach(function (section, key) {
                            if (section.seconds > 59) {
                                let minutes = parseInt(section.seconds / 60);
                                self.sections[key].minutes += minutes;
                                self.sections[key].seconds -= minutes * 60;
                            }

                            let mapIdx = self.map.findIndex(
                                x => x.id === section.id
                            );
                            if (mapIdx != -1) {
                                self.map[mapIdx].minutes =
                                    self.sections[key].minutes;
                                self.map[mapIdx].seconds =
                                    self.sections[key].seconds;
                            } else {
                                self.map.forEach(function (map, idxM) {
                                    mapIdx = map.children.findIndex(
                                        x => x.id === section.id
                                    );
                                    if (mapIdx != -1) {
                                        self.map[idxM].children[
                                            mapIdx
                                            ].minutes = self.sections[key].minutes;
                                        self.map[idxM].children[
                                            mapIdx
                                            ].seconds = self.sections[key].seconds;
                                    }
                                });
                            }
                        });
                    });

                    await self.getKeepData();
                    if (!self.keep || self.keep == "") {
                        self.keep = self.course.default_keep;
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        async getCourseStudent(onlyCourseStatus = false) {
            let $end = "/api/get-student-course/" + this.studentCourseId;

            await axios
                .get($end)
                .then(function (response) {
                    response = response.data;
                    if (response && response.lessons_passed) {
                        JSON.parse(response.lessons_passed).forEach(
                            function (lesson) {
                                $("#map-lesson-" + lesson).addClass(
                                    "passed"
                                );
                                $("#map-mobile-lesson-" + lesson).addClass(
                                    "passed"
                                );
                            }
                        );
                    }
                    if (response && response.quizzes_passed) {
                        JSON.parse(response.quizzes_passed).forEach(
                            function (quiz) {
                                $("#map-quiz-" + quiz).addClass("passed");
                                $("#map-mobile-quiz-" + quiz).addClass(
                                    "passed"
                                );
                                $("#map-quiz-" + quiz).removeClass(
                                    "failed"
                                );
                                $("#map-mobile-quiz-" + quiz).removeClass(
                                    "failed"
                                );
                            }
                        );
                    }

                    if (response && response.quizzes_failed) {
                        JSON.parse(response.quizzes_failed).forEach(
                            function (quiz) {
                                $("#map-quiz-" + quiz).addClass("failed");
                                $("#map-mobile-quiz-" + quiz).addClass(
                                    "failed"
                                );
                            }
                        );
                    }

                })
                .catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        keepModalClosed() {
            this.showStudentKeep = false;
        }
    }
}
</script>

<style scoped>

.subnav-link {
    margin: 0;
}

</style>
